import EventEmitter from 'events';
export default class Timeline extends EventEmitter {
    constructor() {
        super();
        this.container = document.querySelector('.js-timeline');
        this.variants = Array.from(this.container.querySelectorAll('[data-variant]'));
        this.value = 0;
        this.isHandlersInitialized = false;
        this.init();
    }
    setValues() {
        this.value = 0;
        this.variants = Array.from(this.container.querySelectorAll('[data-variant]'));
    }
    reset() {
        this.variants.forEach((item) => item.classList.remove('is-active'));
        this.setValues();
        this.emit('onReset');
    }
    setCurrentValue(value) {
        this.value = value;
    }
    getCurrentValue() {
        return this.value;
    }
    initHandlers() {
        this.setValues();
        this.reset();
        if (this.isHandlersInitialized) {
            return;
        }
        this.isHandlersInitialized = true;
        this.variants.forEach((item) => {
            item.addEventListener('touchstart', () => item.classList.add('is-touched'));
            item.addEventListener('touchend', () => item.classList.remove('is-touched'));
            item.addEventListener('click', () => {
                if (this.container.classList.contains('is-choosed')) {
                    return;
                }
                this.variants.forEach((variant) => {
                    variant.classList.remove('is-active');
                });
                this.container.classList.add('is-choosed');
                item.classList.add('is-active');
                const value = Number(item.dataset.variant) * 25;
                this.setCurrentValue(value);
                this.emit('onValueUpdated', { data: value, target: item });
            });
        });
    }
    init() {
        this.initHandlers();
    }
}
